// @ts-nocheck
import { get } from 'lodash'
import { FormFieldLayout } from '../../generic'
import { FormInput } from '../../generic'

export default function DualTextField({
  errors,
  inputType,
  keys,
  maxlength,
  onChange,
  placeholders,
  style,
  disabled = false,
  values,
  ...props
}) {
  const firstKey = keys[0]
  const lastKey = keys[1]
  const firstKeyError = get(errors, firstKey)
  const lastKeyError = get(errors, lastKey)
  return (
    <FormFieldLayout hasErrors={!!firstKeyError || !!lastKeyError} {...props}>
      <div style={{ ...style, ...styles.wrapper }}>
        <FormInput
          error={firstKeyError}
          onChange={(e) => onChange({ key: firstKey, value: e.target.value })}
          placeholder={placeholders && placeholders[0]}
          style={{ marginRight: 5, width: '100%' }}
          type={inputType}
          disabled={disabled}
          maxLength={maxlength}
          value={get(values, firstKey)}
          // eslint-disable-next-line react/prop-types
          data-testid={
            props['data-testid'] ? `${props['data-testid']}-first` : undefined
          }
        />
        <FormInput
          error={lastKeyError}
          onChange={(e) => onChange({ key: lastKey, value: e.target.value })}
          placeholder={placeholders && placeholders[1]}
          style={{ marginLeft: 5, width: '100%' }}
          type={inputType}
          disabled={disabled}
          maxLength={maxlength}
          value={get(values, lastKey)}
          // eslint-disable-next-line react/prop-types
          data-testid={
            props['data-testid'] ? `${props['data-testid']}-last` : undefined
          }
        />
      </div>
    </FormFieldLayout>
  )
}

const styles = {
  wrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
}
